import { Divider as UclDivider } from '@rbilabs/universal-components';

export const Divider = UclDivider.withConfig({
  marginY: '$4',
  orientation: 'horizontal',
  thickness: '1',
});
